import { SearchOutlined } from '@icon';
import { Table, TextField } from '@ui';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

type TProps = {
  title: string;
  onSearch?(query: string): void;
};

const SearchBar: React.FC<TProps> = ({ title, onSearch }) => {
  const { formatMessage } = useIntl();
  const [query, setQuery] = React.useState('');

  const onChange = (e: any) => {
    const value = e.currentTarget.value;
    setQuery(e.currentTarget.value);
    if (value.length > 1) {
      onSearch?.(value);
    }
    if (value.length === 0) {
      onSearch?.('');
    }
  };

  return (
    <Table.Header
      title={<FormattedMessage id={title} />}
      extra={
        <TextField
          value={query}
          onChange={onChange}
          right={<TextField.Icon Icon={SearchOutlined} />}
          style={{ width: 267 }}
          clearable
          placeholder={formatMessage({ id: 'placeholder.search' })}
        />
      }
    />
  );
};

export default SearchBar;
